export const classes = {
  paper: {
    background: 'transparent',
  },
  paperAnchorDockedLeft: {
    borderRight: 0,
  },
  paperAnchorDockedTop: {
    borderBottom: 0,
  },
  paperAnchorDockedRight: {
    borderLeft: 0,
  },
  paperAnchorDockedBottom: {
    borderTop: 0,
  },
};
